import { DOCUMENT_UPLOAD, IMAGE_UPLOAD, MEDIA_UPLOAD, DOCUMENT_UPLOAD_PUBLIC } from './type';

const initalState = {
  documentUrlData: [],
  imageUrlData: [],
  videoUrlData: [],
  documentUrlDataPublic: []
};

const fileUploadReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case DOCUMENT_UPLOAD:
      return {
        ...state,
        documentUrlData: payload,
      };
    case IMAGE_UPLOAD:
      return {
        ...state,
        imageUrlData: payload,
      };
    case MEDIA_UPLOAD:
      return {
        ...state,
        videoUrlData: payload,
      };
    case DOCUMENT_UPLOAD_PUBLIC:
      return {
        ...state,
        documentUrlDataPublic: payload
      }
    default:
      return {
        ...state,
      };
  }
};

export default fileUploadReducer;
